import { Navigate, type RouteObject } from "react-router-dom";
import { siteConfig } from "../config/site";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacy from "../pages/Privacy";
import ThankYou from "../pages/ThankYou";
import SobreNos from "../pages/SobreNos";
import Contato from "../pages/Contato";
import Servico from "../pages/Servico";
import Blog from "../pages/Blog";
import Article from "../pages/Blog/Article";
import PinturaPladur from "../pages/PinturaPladur";
import { climatizacaoServicesList } from "../data/climatizacaoServices";
import Zona from "../pages/Zona";
import Zonas from "../pages/Zonas";
import { zonas } from "../data/zonas";
import { limpezaServicesList } from "../data/limpezaServices";

const isEletrodomesticosSite = siteConfig.domain === 'alphaservices.pt';
const isPortoSite = siteConfig.domain === 'alphacanalizacoesporto.pt';
const isClimatizacaoSite = siteConfig.domain === 'alphaclimatizacao.pt';
const isCleanSite = siteConfig.domain === 'alphaclean.pt';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...(isEletrodomesticosSite ? [] : [
    {
      path: "/sobre-nos",
      element: <SobreNos />,
    },
    {
      path: "/contato",
      // Climatização sem página de contacto: links antigos vão para a home
      element: isClimatizacaoSite ? <Navigate to="/" replace /> : <Contato />,
    },
    {
      path: "/servico/:id",
      element: <Servico />,
    },
  ]),
  // Blog desativado no site de climatização e limpeza até haver artigos próprios
  ...(isEletrodomesticosSite || isClimatizacaoSite || isCleanSite ? [] : [
    {
      path: "/blog",
      element: <Blog />,
    },
    {
      path: "/blog/:slug",
      element: <Article />,
    },
  ]),
  // Rotas exclusivas para alphaclimatizacao.pt: URLs curtos por serviço
  ...(isClimatizacaoSite ? [
    ...climatizacaoServicesList.map((service) => ({
      path: `/${service.slug}`,
      element: <Servico serviceId={service.id} />,
    })),
    {
      path: "/simulador-btu",
      // Simulador removido: links antigos vão para a home
      element: <Navigate to="/" replace />,
    },
    // SEO local: hub, home de cada zona e serviço x zona
    {
      path: "/zonas",
      element: <Zonas />,
    },
    ...zonas.map((zona) => ({
      path: `/ar-condicionado-${zona.slug}`,
      element: <Zona zonaSlug={zona.slug} />,
    })),
    ...zonas.flatMap((zona) =>
      climatizacaoServicesList.map((service) => ({
        path: `/${service.slug}-${zona.slug}`,
        element: <Servico serviceId={service.id} zonaSlug={zona.slug} />,
      }))
    ),
  ] : []),
  // Rotas exclusivas para alphaclean.pt: URLs curtos por serviço
  ...(isCleanSite ? [
    ...limpezaServicesList.map((service) => ({
      path: `/${service.slug}`,
      element: <Servico serviceId={service.id} />,
    })),
  ] : []),
  // Rotas exclusivas para alphacanalizacoesporto.pt
  ...(isPortoSite ? [
    {
      path: "/pintura-pladur",
      element: <PinturaPladur />,
    },
  ] : []),
  {
    path: "/politica-de-privacidade",
    element: <Privacy />,
  },
  {
    path: "/obrigado/:id?",
    element: <ThankYou />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
